import { createTheme as o } from "./ghl-ui.es855.js";
import r from "./ghl-ui.es1157.js";
import t from "./ghl-ui.es1130.js";
function e() {
  return {
    toolbarIconColor: "rgba(255, 255, 255, .9)",
    toolbarColor: "rgba(0, 0, 0, .35)",
    toolbarBoxShadow: "none",
    toolbarBorderRadius: "24px"
  };
}
const n = o({
  name: "Image",
  common: r,
  peers: {
    Tooltip: t
  },
  self: e
});
export {
  n as imageLight
};
